import TopbarSearchInput from './TopbarSearchInput.vue';

export default TopbarSearchInput;
